
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.048 11.216a1.004 1.004 0 00-1.5-.688c-.72.429-1.42.946-2.17 1.494-1.32.966-2.83 2.06-4.829 3.006-.71.339-1.43.648-2.13.946-2.59 1.115-5.049 2.16-6.298 4.142-.83 1.304-1.7 3.315-1.17 5.515.37 1.514 1.35 2.838 2.91 3.963-3.16 5.057-5.8 11.21-7.49 15.56-4.069-12.832-10.928-26.253-14.807-32.127-.3-.458-.92-.587-1.38-.288a.992.992 0 00-.29 1.374c3.97 6.023 11.618 21.126 15.408 34.416.12.419.49.707.93.727h.04c.42 0 .8-.259.94-.657 1.16-3.196 4.378-11.568 8.358-17.98 1.95 1.006 3.68 1.424 5.17 1.424 2.499 0 4.319-1.155 5.328-2.589.74-1.055 3.17-4.898 3.28-10.304.08-3.564.05-5.884-.3-7.934zm-1.7 7.894c-.1 4.839-2.26 8.264-2.92 9.2-1.45 2.06-4.439 2.26-7.758.617 1.46-2.12 3-3.923 4.57-5.068a.998.998 0 10-1.18-1.613c-1.78 1.305-3.5 3.306-5.12 5.665-1.12-.816-1.81-1.742-2.06-2.758-.37-1.523.3-3.006.92-3.982.92-1.453 3.1-2.39 5.4-3.375.72-.308 1.46-.627 2.199-.976 2.17-1.025 3.76-2.18 5.15-3.195.24-.18.48-.349.71-.518.15 1.573.15 3.455.09 6.003z"}})])
          )
        }
      }
    